import {ReviewsStateType} from '../../../page/main/reviews/reviews-state/reviews-state-type';
import {fetchAndDeserialize, patchAndDeserialize, postAndDeserialize} from '../../../util/api-adapter';
import {FetchMethodEnum, fetchNoContent} from '../../../util/fetch';
import {objectToUrlParameters} from '../../../util/url';
import {getCsrfHeaders, mainApiHeaders, rootApiUrl} from '../../api/api-const';
import {reviewsStateFilterToUrlObject} from '../reviews-helper';

import {
    exportColumnsCatalogSchema,
    exportConstructorExportResponseSchema,
    exportConstructorLimitsSchema,
    exportTemplateSchema,
    exportTemplatesListSchema,
} from './export-constructor-schema';
import {
    CreateExportTemplatePayloadType,
    ExportColumnCatalogItemType,
    ExportConstructorExportPayloadType,
    ExportConstructorLimitsType,
    ExportTemplateType,
    UpdateExportTemplatePayloadType,
} from './export-constructor-type';

const exportTemplatesBasePath = '/v4/reviews/export_templates';
const exportConstructorBasePath = '/v4/reviews/export_constructor';

function getExportTemplateUrl(templateId: number): string {
    return `${exportTemplatesBasePath}/${templateId}/`;
}

export function fetchExportTemplates(): Promise<Array<ExportTemplateType>> {
    return fetchAndDeserialize(`${exportTemplatesBasePath}/`, exportTemplatesListSchema);
}

export function fetchExportTemplate(templateId: number): Promise<ExportTemplateType> {
    return fetchAndDeserialize(getExportTemplateUrl(templateId), exportTemplateSchema);
}

export function createExportTemplate(payload: CreateExportTemplatePayloadType): Promise<ExportTemplateType> {
    return postAndDeserialize(`${exportTemplatesBasePath}/`, exportTemplateSchema, payload);
}

export function updateExportTemplate(
    templateId: number,
    payload: UpdateExportTemplatePayloadType
): Promise<ExportTemplateType> {
    return patchAndDeserialize(getExportTemplateUrl(templateId), exportTemplateSchema, payload);
}

export function deleteExportTemplate(templateId: number): Promise<void> {
    return fetchNoContent(`${rootApiUrl}${getExportTemplateUrl(templateId)}`, {
        method: FetchMethodEnum.delete,
        headers: {...mainApiHeaders, ...getCsrfHeaders()},
    });
}

export function fetchExportConstructorColumns(): Promise<Array<ExportColumnCatalogItemType>> {
    return fetchAndDeserialize(`${exportConstructorBasePath}/columns/`, exportColumnsCatalogSchema);
}

export function fetchExportConstructorLimits(): Promise<ExportConstructorLimitsType> {
    return fetchAndDeserialize(`${exportConstructorBasePath}/limits/`, exportConstructorLimitsSchema);
}

function buildExportFilterQuery(
    reviewsState: ReviewsStateType,
    mainFilterKey: string
): Record<string, string | number | boolean> {
    const filterParameters = reviewsStateFilterToUrlObject(reviewsState);

    return {
        ...filterParameters,
        ...(!reviewsState.company_ids ? {filter_key: mainFilterKey} : {}),
        timestamp: Date.now(),
    };
}

async function fetchExportConstructorExport(
    payload: ExportConstructorExportPayloadType,
    reviewsState: ReviewsStateType,
    mainFilterKey: string
): Promise<void> {
    const filterQuery = buildExportFilterQuery(reviewsState, mainFilterKey);
    const searchParameters = objectToUrlParameters(filterQuery);

    await postAndDeserialize(
        `${exportConstructorBasePath}/export/?${searchParameters}`,
        exportConstructorExportResponseSchema,
        payload
    );
}

export function fetchExportConstructorStatus(
    payload: ExportConstructorExportPayloadType,
    reviewsState: ReviewsStateType,
    mainFilterKey: string
): Promise<void> {
    return fetchExportConstructorExport(payload, reviewsState, mainFilterKey);
}
